import { render, staticRenderFns } from "./ConnectWalletButton.vue?vue&type=template&id=50476248"
import script from "./ConnectWalletButton.vue?vue&type=script&lang=js"
export * from "./ConnectWalletButton.vue?vue&type=script&lang=js"
import style0 from "./ConnectWalletButton.vue?vue&type=style&index=0&id=50476248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports